<div class="tw-flex tw-items-center tw-space-x-1 tw-gap-y-1 tw-flex-wrap">
  <span *ngIf="label" [class]="labelClass">{{ label }}</span>
  <div *ngIf="!(layoutService.isSmallScreen$ | async)" class="tw-flex tw-items-center">
    <mat-button-toggle-group
      [value]="selectedValue"
      name="optionToggle{{ label }}"
      aria-label="Options"
      (change)="onToggleChange($event)"
      class="moneyBattleToggle tw-h-6 tw-border tw-border-solid tw-border-gray-300 dark:tw-border-none">
      <!-- Visible options (1 or 2) -->
      <mat-button-toggle
        *ngFor="let option of visibleOptions"
        [value]="option.value"
        class="tw-px-2 tw-h-6 tw-text-xs tw-leading-6 tw-min-w-[32px]">
        <span>{{ option.displayText }}</span>
      </mat-button-toggle>

      <!-- More options button -->
      <mat-button-toggle
        *ngIf="menuOptions.length > 0"
        value="more"
        class="ellipsis-toggle tw-px-2 tw-h-6 tw-text-xs tw-leading-6 tw-min-w-[32px]"
        [matMenuTriggerFor]="optionsMenu"
        (click)="handleMoreClick($event)">
        <mat-icon class="tw-text-dark-light-dynamic">more_horiz</mat-icon>
      </mat-button-toggle>
    </mat-button-toggle-group>

    <!-- Menu for additional options -->
    <mat-menu #optionsMenu="matMenu" class="option-toggle-menu">
      <button
        *ngFor="let option of menuOptions"
        mat-menu-item
        (click)="onMenuOptionSelected(option)">
        <span>{{ option.displayText }}</span>
      </button>
    </mat-menu>
  </div>
  <div *ngIf="layoutService.isSmallScreen$ | async" class="tw-flex tw-items-center">
    <mat-select
      [value]="selectedValue"
      (selectionChange)="onSelectChange($event)"
      class="charts-options-mobile-select">
      <mat-option *ngFor="let option of options" [value]="option.value">
        {{ option.displayText }}
      </mat-option>
    </mat-select>
  </div>
</div>
